import { render, staticRenderFns } from "./table-management.vue?vue&type=template&id=32cc9020&scoped=true&"
import script from "./table-management.vue?vue&type=script&lang=js&"
export * from "./table-management.vue?vue&type=script&lang=js&"
import style0 from "./table-management.vue?vue&type=style&index=0&id=32cc9020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cc9020",
  null
  
)

export default component.exports